/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Type of LLM resource
 */
export const LlmResourceType = {
  Completion: "completion",
  File: "file",
  VectorStore: "vector_store",
  Conversation: "conversation",
  Response: "response",
  Skill: "skill",
} as const;
/**
 * Type of LLM resource
 */
export type LlmResourceType = ClosedEnum<typeof LlmResourceType>;

/** @internal */
export const LlmResourceType$inboundSchema: z.ZodNativeEnum<
  typeof LlmResourceType
> = z.nativeEnum(LlmResourceType);
/** @internal */
export const LlmResourceType$outboundSchema: z.ZodNativeEnum<
  typeof LlmResourceType
> = LlmResourceType$inboundSchema;
